import React from "react";
import { Navigate, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { LayoutDashboard, Home as HomeIcon, Calendar, Inbox, LogOut, Building2, Users } from "lucide-react";

const navItems = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/proprieta", label: "Proprietà", icon: Building2 },
  { to: "/admin/calendario", label: "Calendario", icon: Calendar },
  { to: "/admin/prenotazioni", label: "Prenotazioni", icon: Inbox },
  { to: "/admin/messaggi", label: "Messaggi", icon: Inbox },
];

export default function AdminLayout({ children }) {
  const { user, loading, logout } = useAuth() || {};
  const nav = useNavigate();

  if (loading) return <div className="p-10">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;

  const isAdmin = user.role === "admin";
  const items = isAdmin ? [...navItems, { to: "/admin/staff", label: "Staff", icon: Users }] : navItems;

  return (
    <div className="min-h-screen flex bg-[var(--mel-bg)]">
      <aside className="w-64 border-r border-[var(--mel-border)] bg-[var(--mel-surface)] flex-shrink-0 hidden md:flex flex-col">
        <div className="p-6 border-b border-[var(--mel-border)]">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-full flex items-center justify-center" style={{ background: 'var(--mel-primary)' }}>
              <span className="font-serif text-white text-sm">M</span>
            </div>
            <div>
              <div className="font-serif text-sm">Il Melograno</div>
              <div className="text-[10px] tracking-widest uppercase text-[var(--mel-muted)]">Gestionale</div>
            </div>
          </div>
        </div>
        <nav className="p-4 flex-1 space-y-1" data-testid="admin-nav">
          {items.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end}
              data-testid={`admin-nav-${it.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm transition-colors ${isActive ? 'bg-[var(--mel-primary)] text-white' : 'hover:bg-[var(--mel-bg)]'}`
              }
            >
              <it.icon size={16} /> {it.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-[var(--mel-border)]">
          <div className="text-xs text-[var(--mel-muted)] mb-2">{user.email}</div>
          <div className="flex items-center justify-between">
            <span className="text-[10px] uppercase tracking-widest px-2 py-1 rounded-full bg-[var(--mel-bg)]">{user.role}</span>
            <button onClick={() => { logout(); nav("/"); }} className="text-xs flex items-center gap-1 text-[var(--mel-muted)] hover:text-[var(--mel-primary)]" data-testid="admin-logout">
              <LogOut size={14} /> Esci
            </button>
          </div>
          <NavLink to="/" className="mt-3 flex items-center gap-2 text-xs text-[var(--mel-muted)] hover:text-[var(--mel-primary)]" data-testid="admin-back-site">
            <HomeIcon size={14} /> Torna al sito
          </NavLink>
        </div>
      </aside>
      <main className="flex-1 overflow-x-auto">{children}</main>
    </div>
  );
}
